import React from 'react';
import { motion } from 'framer-motion';

import Icon from '../../../components/AppIcon';

const QuickActions = ({ onTabChange }) => {
  const actions = [
    {
      title: 'Add New Post',
      description: 'Create a new blog article',
      icon: 'Plus',
      color: 'primary',
      action: () => onTabChange?.('content')
    },
    {
      title: 'Upload Media',
      description: 'Add images and videos',
      icon: 'Upload',
      color: 'secondary',
      action: () => onTabChange?.('media')
    },
    {
      title: 'View Inquiries',
      description: 'Check new messages',
      icon: 'Mail',
      color: 'accent',
      action: () => onTabChange?.('inquiries')
    },
    {
      title: 'Site Settings',
      description: 'Configure your site',
      icon: 'Settings',
      color: 'success',
      action: () => alert('Settings panel coming soon!')
    }
  ];

  return (
    <div className="space-y-4">
      <h2 className="text-xl sm:text-2xl font-bold text-foreground">Quick Actions</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {actions?.map((action, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="relative overflow-hidden rounded-xl p-4 sm:p-6 backdrop-blur-xl border border-border/50 cursor-pointer group touch-manipulation"
            style={{
              background: 'linear-gradient(135deg, rgba(30, 41, 59, 0.6), rgba(15, 23, 42, 0.8))'
            }}
            onClick={action?.action}
          >
            {/* Hover Glow */}
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-2xl"
              style={{
                background: `var(--color-${action?.color})`
              }}
            />

            <div className="relative z-10 space-y-3 sm:space-y-4">
              <div
                className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center"
                style={{
                  background: `linear-gradient(135deg, var(--color-${action?.color}), var(--color-secondary))`
                }}
              >
                <Icon name={action?.icon} size={20} color="white" />
              </div>

              <div>
                <h3 className="text-sm sm:text-lg font-semibold text-foreground mb-1">
                  {action?.title}
                </h3>
                <p className="text-xs sm:text-sm text-muted-foreground line-clamp-2">
                  {action?.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;